import { CreateQuestionPrompt } from '@/types/module.types';

export const GetDefaultQuestionPrompt = (): CreateQuestionPrompt => ({
  title: { base: '', changed: '' },
  settings: {
    likes: true,
    replies: true,
    anonymous_replies: true,
  },
});
